import React from "react";
import {useAuth} from "../context";
import {CustomCardHome, CustomCardHomeBottom} from "./_components";
import {Carousel, Figure} from "react-bootstrap";
import {useWindowSize} from "../hooks";
import {Link} from "react-router-dom";
import {ABCardShop, ABCardShopBottom, ABContainer} from "./shop/_components/ABShop";
import {WhiteCard} from "./device/_components/WhiteCard";
import {RenderMarkdownGitHub} from "../markdown/utils/utilsForMarkdown";

export function LandingPage() {
    return <>
        <CustomCarousel/>

        <ABContainer>
            <LoggedInMsg/>
            <ABBlog/>
            <OurService/>
        </ABContainer>
    </>
}

function LoggedInMsg() {
    const {loggedIn, userId, user} = useAuth()

    const welcome = loggedIn ? `Hi ${user?.first_name || user?.username}! Manage your account and unlock more value.` : "Get started with AltraBits"

    return <>
        <LandingTitle title={welcome}/>

        <div className="d-flex flex-wrap flex-lg-nowrap justify-content-around justify-content-md-between gap-2 gap-sm-4">
            <div className="flex-grow-1">
                <CardLeft/>
            </div>
            <div className="d-flex flex-row flex-lg-column justify-content-around justify-content-lg-between flex-wrap">
                <CardTopRight loggedIn={loggedIn} userId={userId}/>
                <CardBottomRight loggedIn={loggedIn} userId={userId}/>
                <ABCardShop>
                    <CustomCardHome title="Learn and Build" subtitle="Browse tutorials, use cases, and guides to get the most out of your devices"
                                    buttonName="Get inspired"
                                    to="/git/Guide/README.md"/>
                </ABCardShop>
            </div>
        </div>

    </>
}

function CardLeft({}) {
    return <ABCardShop styleWidth={null}>
        <CustomCardHome title="Grow your network" subtitle="Explore and purchase new devices to enhance your setup"
                        buttonName="Shop">
            <Figure className="d-flex justify-content-center">
                <Link to="/shop">
                    <Figure.Image
                        src="/landing/landing_page_wide.webp"
                        alt="Landing page"
                        //height="400px"
                        // width="400px"
                        loading="lazy"
                    />
                </Link>
            </Figure>
        </CustomCardHome>
    </ABCardShop>
}

function CardTopRight({loggedIn, userId}) {
    return <ABCardShop>
        {loggedIn ?
            <CustomCardHome title="Activate Device" subtitle="Start using your new device by activating it here" buttonName="Activate"
                            to={`/device/${userId}/activate`}/>
            :
            <CustomCardHome title="First Visit?" subtitle="Create a new account and start managing your network" buttonName="Create an account"
                            to="/account/signup"/>
        }
    </ABCardShop>
}

function CardBottomRight({loggedIn, userId}) {
    return <ABCardShop>
        {loggedIn ?
            <CustomCardHome title="Monitor and Control" subtitle="View and update all devices linked to your account" buttonName="Your devices"
                            to={`/device/${userId}/hybrid`}/>
            :
            <CustomCardHome title="Already a Customer?" subtitle="Log in to manage your account and access your devices" buttonName="Login"
                            to="/account/login"/>
        }
    </ABCardShop>
}

function OurService() {

    return <div>
        <LandingTitle title="Our service"/>
        <div className="d-flex flex-wrap flex-lg-nowrap justify-content-around gap-2 gap-sm-4">

            <ABCardShopBottom>
                <CustomCardHomeBottom icon="bi bi-cloud-download" title="Up to date" subtitle="Check the downloads for the latest firmware updates"
                                      buttonName="Update Center" to="/git/Firmware/README.md"/>
            </ABCardShopBottom>
            <ABCardShopBottom>
                <CustomCardHomeBottom icon="bi bi-headset" title="Technical support" subtitle="The AltraBits team will help you individually for each specific system"
                                      buttonName="Support" to="/contact-us"/>
            </ABCardShopBottom>
            <ABCardShopBottom>
                <CustomCardHomeBottom icon="bi bi-hammer" title="Customize" subtitle="AltraBits products can be customized to special requirements"
                                      buttonName="Customize" to="/contact-us"/>
            </ABCardShopBottom>
            <ABCardShopBottom>
                <CustomCardHomeBottom icon="bi bi-download" title="Download" subtitle="AltraBits useful tools and programs to use with our products"
                                      buttonName="Download" to="/git/Download/README.md"/>
            </ABCardShopBottom>
        </div>
    </div>

}


function CustomCarousel() {
    const {width} = useWindowSize();
    const breakpoints = {sm: 576, md: 768, lg: 992};

    // Calculate height directly based on width
    const imageHeight =
        width < breakpoints.md
            ? '300px'
            : '500px'


    const imageStyle = {
        height: imageHeight,
        objectFit: 'cover',
        width: '100%',
    };

    return (
        <Carousel className="mb-4">
            <Carousel.Item>
                <img
                    // className="d-block"
                    src="/landing/input.jpg"
                    alt="Input"
                    style={imageStyle}
                />
                <Carousel.Caption>
                    <div className="text-capitalize text-start">
                        <Link to="/shop"
                              className="link-light link-underline link-underline-opacity-0">
                            <h3>Gateways to Control and Surveillance</h3>
                            <p>Exploring devices That Drive Hybrid Systems and Reactive Outputs</p>
                        </Link>
                    </div>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    // className="d-block "
                    src="/landing/hybrid.jpg"
                    alt="Hybrid"
                    style={imageStyle}
                />
                <Carousel.Caption>
                    <div className="text-capitalize text-start">
                        <Link to="/shop"
                              className="link-light link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                            <h3 className="text-capitalize">Bridging Control and Communication</h3>
                            <p className="text-capitalize">Configurable Devices That Transmit, Receive, and Adapt Across Intelligent Systems</p>
                        </Link>
                    </div>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    // className="d-block"
                    src="/landing/output.jpg"
                    alt="Output"
                    style={imageStyle}
                />
                <Carousel.Caption>
                    <div className="text-capitalize text-start">
                        <Link to="/shop"
                              className="link-light link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                            <h3 className="text-capitalize">Executing the Final Command</h3>
                            <p className="text-capitalize">Dedicated Devices for Action and Response in Automated Systems</p>
                        </Link>
                    </div>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    // className="d-block"
                    src="/landing/audiowaves.jpg"
                    alt="audiowaves"
                    style={imageStyle}
                />
                <Carousel.Caption>
                    <div className="text-capitalize text-start">
                        <Link to="/shop"
                              className="link-light link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                            <h3 className="text-capitalize">AI-Driven Command Execution</h3>
                            {/*<p className="text-capitalize">Empowering Automated Systems with Intelligent Action and Response</p>*/}
                            <p className="text-capitalize">Harnessing AI to Optimize Device Actions in Real Time</p>
                        </Link>
                    </div>
                </Carousel.Caption>
            </Carousel.Item>
        </Carousel>
    )
}

function LandingTitle({title}) {
    return <div className="text-start fs-4 fw-bold mt-4 ms-2 ms-sm-0">{title}</div>
}

function ABBlog() {
    return <>
        <LandingTitle title="News"/>
        <WhiteCard>
            <RenderMarkdownGitHub github="https://raw.githubusercontent.com/altrabits/AB_Documents/main/Blog/Blog.md" shrink/>

            <Link to="/git/Blog/Blog.md" className="link-underline link-underline-opacity-0 link-underline-opacity-75-hover">Visit blog</Link>
        </WhiteCard>
    </>
}